import { Alert, Box, Button, Container, Typography } from '@mui/material';
import { useStytchLogout } from '../hooks/useStytchLogout';

export default function NoAccessPage(): React.ReactElement {
  const { signOut } = useStytchLogout();

  return (
    <Container maxWidth="sm" sx={{ py: 10 }}>
      <Box
        sx={{
          backgroundColor: '#F4F7F5',
          border: '1px solid #D9E3DD',
          borderRadius: 3,
          p: 4,
        }}
      >
        <Typography sx={{ color: '#2B3B33', fontSize: 28, fontWeight: 700, mb: 2 }}>
          Access not enabled
        </Typography>
        <Alert severity="info" sx={{ mb: 3 }}>
          Your account is authenticated, but it does not currently have a product role.
        </Alert>
        <Typography sx={{ color: '#42554B', lineHeight: 1.6, mb: 3 }}>
          Contact Mento support or your administrator if you expected member or coach access.
        </Typography>
        <Button variant="outlined" onClick={() => void signOut()}>
          Sign out
        </Button>
      </Box>
    </Container>
  );
}
